import { Component } from '@angular/core';

@Component({
  selector: 'shared-custom-loader',
  templateUrl: './custom-loader.component.html',
  styleUrl: './custom-loader.component.scss',
  standalone: false,
})
export class CustomLoaderComponent {

}
